///-- THIS FILE IS GENERATED --///
export enum Visibility {

    INVISIBLE = "pinata-invisible",

    VISIBLE = "pinata-visible",

}